import { useContext } from "react";
import { DisplayOptionsContext } from "../components/DisplayOptionsProvider";
const defaultDisplayOptions = {
  displayTimetableIds: false,
  cardStyleLegs: false,
  displaySeatReservations: false
};
const useDisplayOptions = () => {
  const ctx = useContext(DisplayOptionsContext);
  return ctx || defaultDisplayOptions;
};
var useDisplayOptions_default = useDisplayOptions;
export {
  useDisplayOptions_default as default
};
